import type { App } from "vue";
import { createI18n } from "vue-i18n";
import { localStg } from "@/utils/storage";
import zhCN from "./langs/zh-cn.json";
import enUS from "./langs/en-us.json";
import esES from "./langs/es-es.json";

const messages = {
  "zh-CN": zhCN,
  "en-US": enUS,
  "es-ES": esES,
};

const defaultLocale = getDefaultLocale();

const i18n = createI18n({
  locale: defaultLocale,
  fallbackLocale: "en-US",
  messages,
  legacy: false,
});

/**
 * 设置国际化
 * @param app 应用实例
 */
export function setupI18n(app: App) {
  app.use(i18n);
}

type LangType = "zh-CN" | "en-US";

export const $t = i18n.global.t;

export function setLocale(locale: LangType) {
  i18n.global.locale.value = locale;
  localStg.set("lang", locale);
}

export function getDefaultLocale(): LangType {
  const value = localStg.get("lang");
  if (value) {
    return value as LangType;
  }
  return "en-US";
}
